import "./iFDO.css";

/**
 * Checks if part of the given argument is contained in a list of known iFDO keys, and return the corresponding iFDO key
 * 
 * Example:
 * Returns 'image-acquisition' for iFDOSimilarKey = 'acquisition' or iFDOSimilarKey = 'iFDO-acquisition'
 * 
 * @param {string} iFDOSimilarKey key that is almost similar to iFDO key
 * @returns {string} iFDO key
 */
export function guessIFDOKey(iFDOSimilarKey) {
    const iFDOSearchKeyDict = {
        'image-acquisition': new RegExp('acquisition', 'i'),
        'image-marine-zone': new RegExp('marine(?:[^a-zA-Z\d]{0,1})zone', 'i'),
        'image-deployment': new RegExp('deployment', 'i'),
        'image-navigation': new RegExp('navigation', 'i'),
        'image-illumination': new RegExp('illumination', 'i'),
        'image-scale-reference': new RegExp('scale(?:[^a-zA-Z\d]{0,1})reference', 'i'),
        'image-quality': new RegExp('quality', 'i'),
        'image-pixel-magnitude': new RegExp('pixel(?:[^a-zA-Z\d]{0,1})magnitude', 'i'),
        'image-spectral-resolution': new RegExp('spectral(?:[^a-zA-Z\d]{0,1})resolution', 'i'),
        'image-capture-mode': new RegExp('capture-mode', 'i'),
        'image-license': new RegExp('license', 'i')
    }

    for (const iFDOSearchKey in iFDOSearchKeyDict) {
        if (iFDOSimilarKey.match(iFDOSearchKeyDict[iFDOSearchKey])) {
            return iFDOSearchKey
        }
    }
    return null
}

/**
 * For an iFDO key, return its HTML element containing the iFDO icon font class name 
 * Note: Requires the iFDO-icons stylesheet
 * 
 * @memberof vef.ui.media
 * @param {string} iFDOKey 
 * @param {string} iFDOValue 
 * @returns <span> HTML element with iFDO icon class
 */
export function getHTMLOfIFDOIcon(iFDOKey, iFDOValue) {
    const iconIFDOKey = iFDOKey.replace('image-set-', 'image-');
    const iconTitle = `"${iconIFDOKey}: ${iFDOValue}"`;
    const iconHTML = `<span class="icon-${iconIFDOKey + '_' + iFDOValue.replace(' ', '-')}" title=${iconTitle}></span>`
    return iconHTML
}


class TextLayout {
    /**
     * Capitalize the first letter of each word in a sentence, that is not contained in the exception list
     * @param {string} sentence 
     * @param {string[]} exceptions 
     * @returns {string} sentence with capitalized first letter
     */
    static capitalizeFirstLetter(sentence, exceptions = ['and', 'or', 'nor', 'but', 'at', 'by', 'for', 'in', 'of', 'on', 'a', 'an', 'the']) {
        return sentence.replace(/\w*/g, (word) => {
            if (exceptions.includes(word))
                return word
            return word.charAt(0).toUpperCase() + word.substring(1).toLowerCase()
        })
    }
}